import { QuestionNode } from '../../../actionCard/actionCardNodes/question/QuestionNode'

export class TextQuestionNode extends QuestionNode {}
